import type DelayedSendStore from './schema/DelayedSendStore';
import { createStore } from 'owa-satcheljs';

const defaultDelayedSendStore: DelayedSendStore = {
    delayedMailItems: [],
};

export const getStore: () => DelayedSendStore = createStore<DelayedSendStore>(
    'delayedSend',
    defaultDelayedSendStore
);
